import React,{useEffect,useRef,useState,useReducer} from 'react';
import { pan,startPan, zoom, boundPan, constants,invertColor,rotate, scale,imgLoad,resetToOriginal } from './actions';
import  reducer, {initialPosition} from './reducer';

const useViewerUtil = (callback:any) =>{

  //Declarations
  const wrapperRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);
  const translate = {translateX : 0, translateY : 0};
  const pos = {x:0,y:0,z:1,oldX:0,oldY:0};
  const[currentPosition,setCurrentPosition]  =  useState(pos);
  
  const [rotationDeg,setRotationDeg] = useState(constants.ROTATION_DEG);
  const [state, dispatch] = useReducer(reducer, initialPosition);

  const [imageDimension,setImageDimension] = useState({width : 0 , height : 0});

//Constants
  const ZOOM_FACTOR = 0.1;
  const ROTATION_DEG = 90;
 

  //events

  const reset = () => {
    
    state.x = initialPosition.x;
    state.y = initialPosition.y;
    state.z =  initialPosition.z;
    state.invert = initialPosition.invert;
    state.rotationDegree = initialPosition.rotationDegree;
    state.oldX = initialPosition.oldX;
    state.oldY = initialPosition.oldY;
    state.transformOrigin=initialPosition.transformOrigin
   
   
  };
  const resetForNextPrevious = () => {
    

    state.invert = initialPosition.invert;
    state.rotationDegree = initialPosition.rotationDegree;
   
   
  };

  const stateRef=useRef(state);

useEffect(() => {
        stateRef.current=state;
});


const currentState = (position:any, grayscale:any, rotate:any) =>
{
  
 
   setCurrentPosition (position) ;
   
   setRotationDeg (rotate);
}

  

const mouseDown = (e:any) =>{
  
  e.preventDefault();
  e.stopPropagation();

   if(containerRef && containerRef.current)
   {
    containerRef.current.style.cursor = 'grabbing';
     
     dispatch(startPan(e));
      
     
   }
   
  window.addEventListener('mouseup', mouseUp);
  window.addEventListener('mousemove', mouseMove);
}

const mouseMove = (e:any) => {
  e.preventDefault();

 
  // if(state.z === constants.MIN_ZOOM)
  // {
  //   return;
  // }
  
  dispatch(pan(e,wrapperRef,containerRef));
  
  callback({x:stateRef.current.x,y:stateRef.current.y,z:stateRef.current.z,oldX:stateRef.current.oldX,oldY:stateRef.current.oldY} ,null,null);
}
  
const mouseUp = (e:any) => {

  if(containerRef && containerRef.current)
   {
    containerRef.current.style.cursor = '';
   }

  window.removeEventListener('mouseup', mouseUp);
  window.removeEventListener('mousemove', mouseMove);
 

}
  
const mouseLeave = (e:any) => {
  if(containerRef && containerRef.current)
   {
    containerRef.current.style.cursor = '';
   }
  window.removeEventListener('mouseup', mouseUp);
  window.removeEventListener('mousemove', mouseMove);
 
}
  

const mouseWheel = (e:any) => {
  return false; // skipping this functionality for now, this has to be reworked.
  if (wrapperRef.current) {
    dispatch(zoom(e, containerRef,wrapperRef,imgRef));

}

callback({x:stateRef.current.x,y:stateRef.current.y,z:stateRef.current.z,oldX:stateRef.current.oldX,oldY:stateRef.current.oldY} ,null,null);    
}
  
    const toggleGrayscale = (val : number) => {

     dispatch( invertColor(val));
     
      callback(null,stateRef.current.invert,null);
  
    }
    
    const rotateCW = (currentRotation : number,imageWidth:number,imageHeight:number,clientWidth:number,clientHeight:number) => {

      var transformOrigin='top center';
      var x = stateRef.current.x;
      var y = stateRef.current.y;
      var scrollHeight=imageHeight*stateRef.current.z
      var scrollWidth=imageWidth*stateRef.current.z
      var currentRotation =Math.abs(currentRotation)==360?0:currentRotation;
      switch(currentRotation)
      {
        case 0:
        case 180:
          if(scrollHeight>clientWidth)
          {
            x = (scrollHeight-clientWidth)/2
            y = -(scrollHeight/2-imageWidth/2)/stateRef.current.z;
          }
          break;
        default:
          x = 0;
          y = 0;
          break;
      }
      dispatch(rotate(1, currentRotation,transformOrigin,x,y ))
      callback({x:x,y:y,z:constants.MIN_ZOOM,oldX:state.oldX, oldY:state.oldY} ,null,stateRef.current.rotationDegree);
       
      
      }

    const rotateACW = (currentRotation : number,imageWidth:number,imageHeight:number,clientWidth:number,clientHeight:number) =>{
        var transformOrigin='top center';
        var x = stateRef.current.x;
        var y = stateRef.current.y;
        var scrollHeight=imageHeight*stateRef.current.z
        var currentRotation =Math.abs(currentRotation)==360?0:Math.abs(currentRotation)==-270?-90:currentRotation;
        
        switch(currentRotation)
        {
          case 0:
          case -180:
            if(scrollHeight>clientWidth)
            {
              x = (scrollHeight-clientWidth)/2
              y = -(scrollHeight/2-imageWidth/2)/stateRef.current.z;
            }
            break;
          default:
            x = 0;
            y = 0;
            break;
        }
       
       
        dispatch(rotate(-1, currentRotation,transformOrigin,x,y));

         callback({x:x,y:y,z:constants.MIN_ZOOM,oldX:state.oldX, oldY:state.oldY} ,null,stateRef.current.rotationDegree); 
          
      }
  
  const conditionalZoom=(zoomUp:boolean)=> {
    var prevZoom = stateRef.current.z;
    var pX=stateRef.current.x;
    var pY=stateRef.current.y;
    //var scrollWidth=imageWidth*prevZoom;
    var transformOrigin='top left';
    if(Math.abs(stateRef.current.rotationDegree)==90){
      transformOrigin=`${-pX}px ${-pY}px`;
    }
    else if (prevZoom<=1){
       transformOrigin='top center';
    }

    dispatch(scale(prevZoom, zoomUp, pX, pY,transformOrigin))
   
    callback({x:pX,y:pY,z:stateRef.current.z,oldX:stateRef.current.oldX,oldY:stateRef.current.oldY,transformOrigin:stateRef.current.transformOrigin} ,stateRef.current.invert,stateRef.current.rotationDegree);
  }

  const zoomIn = (imageWidth:number,clientWidth:number,clientHeight:number) =>
  {
    
    conditionalZoom(true);
    
  }

  const zoomOut = (imageWidth:number,clientWidth:number,clientHeight:number) =>
  {

    conditionalZoom(false);
  }
  

  const imageLoad  = () => {

    if(wrapperRef && wrapperRef.current && imgRef && imgRef.current)
    {
      var transformOrigin=stateRef.current.z<1?'center top':'left top';
      dispatch(imgLoad(imgRef.current.naturalWidth,imgRef.current.naturalHeight,transformOrigin))
    }
  }

  const resetImage  = () => {

    dispatch(resetToOriginal(-1, 90));

    var x = stateRef.current.x;
    var y = stateRef.current.y;

     callback({x:x,y:y,z:constants.MIN_ZOOM,oldX:state.oldX, oldY:state.oldY} ,null,stateRef.current.rotationDegree); 
   

  }
  const setTransformStyle = (deg : number,scale : number,wrapper : any,image : any) => {

   
   }
    
 return {
  containerRef,
  wrapperRef,
  imgRef,
  mouseDown,
  mouseWheel,
  mouseLeave,
  rotateCW,
  rotateACW,
  toggleGrayscale,
  zoomIn,
  zoomOut,
  reset,
  currentState,
  imageLoad,
  resetImage,
  resetForNextPrevious,
  ...state
 
 
}

}

  export default useViewerUtil;

  